import { createContext, useContext } from "react";

const defaultContext = {
  usesEffectiveAccess: false,
  effectiveAccess: null,
  pageAccessList: [],
  canAccessPage: () => true,
  filterTabsByAccess: (tabs) => tabs ?? [],
  canReturnToApplication: () => true,
};

const EffectiveAccessContext = createContext(defaultContext);

export const useEffectiveAccess = () => useContext(EffectiveAccessContext);

export default EffectiveAccessContext;
